const API_BASE = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

export const PUBLIC_HELP_API = `${API_BASE}/api/public/help`;

const parseJsonResponse = async (response) => {
  const result = await response.json();
  if (!response.ok) {
    const message = result?.message || `Help API failed (${response.status})`;
    throw new Error(message);
  }
  if (!result?.success) {
    throw new Error(result?.message || 'Help API returned an error');
  }
  return result.data;
};

/**
 * @param {string|{ category?: string, audience?: string }} [options]
 * @param {AbortSignal} [signal]
 */
export const fetchPublicHelp = async (options, signal) => {
  const categorySlug = typeof options === 'string' ? options : options?.category;
  const audience = typeof options === 'object' && options !== null ? options?.audience : undefined;

  const params = new URLSearchParams();
  if (categorySlug) params.set('category', categorySlug);
  if (audience) params.set('audience', audience);
  const qs = params.toString() ? `?${params.toString()}` : '';
  const response = await fetch(`${PUBLIC_HELP_API}${qs}`, { signal });
  return parseJsonResponse(response);
};
